import React from 'react';
import FileDropZone from './FileDropZone';

/**
 * ProofUploadField — thin wrapper over the shared FileDropZone (compact 'button'
 * variant), kept as a stable public API for existing consumers (e.g. MatchDialog).
 * Stages the chosen/dropped File to the parent via onFileChange; the parent uploads.
 */
const ProofUploadField = ({ file, onFileChange, label = 'Proof of Document' }) => (
  <FileDropZone
    variant="button"
    file={file}
    onFile={onFileChange}
    accept="application/pdf,image/*"
    label={label}
  />
);

export default ProofUploadField;
